import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./compoments/main-layout";
import FortuneTellingComponent from "../src/compoments/fortune-telling";
import PersonalChartComponent from "../src/compoments/personal-chart";
import DelateWuxAccountComponent from "./compoments/delate-account-component";
import PrivacyComponent from "./compoments/privacy-component";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}></Route>

        {/* 八字排盤首頁-> Fortune Page */}
        <Route path="/bazi" element={<FortuneTellingComponent />}></Route>
        <Route
          path="/personal-chart"
          element={<PersonalChartComponent />}
        ></Route>

        <Route
          path="/delete-wuxaccount"
          element={<DelateWuxAccountComponent />}
        ></Route>

        <Route path="/privacy" element={<PrivacyComponent />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
